'use strict';

var EventFactory = function EventFactory() {
  function Event(event) {
    event = event || {};
    this.market = event.market || null;
    this.name = event.name || null;
    this.type = event.type || null;

    /**
     * Date range start MomentFactory
     * @type {MomentFactory}
     */
    this.startDateMoment = event.startDateMoment || null;

    /**
     * Date range end MomentFactory
     * @type {MomentFactory}
     */
    this.endDateMoment = event.endDateMoment || null;
  }
  return Event;
};
EventFactory.$inject = [];
module.exports = EventFactory;